var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNextArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41 6L8 7.41L12.58 12L8 16.59L9.41 18L15.41 12L9.41 6Z",
    fill: "#4C4C50"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNextArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_next_arrow.029eede91ad8d75c81de3a8b03cbbdbe.svg";